import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    replyData: {
      editorData: "",
      toEmailAddress: [],
      CCemailAddress: [],
      BCCemailAddress: [],
      dropedFiles: [],
      existingAttachmentIds:[]
    },
    replyExpanded: false,
  },
  mutations: {
    setEditorData: (state, data) => {
      state.replyData.editorData = data
    },
    setToEmailAddress: (state, data) => {
      state.replyData.toEmailAddress = data
    },
    setCCemailAddress: (state, data) => {
      state.replyData.CCemailAddress = data
    },
    setBCCemailAddress: (state, data) => {
      state.replyData.BCCemailAddress = data
    },
    setReplyExpanded: (state, data) => {
      state.replyExpanded = data
    },
    setDropedFiles: (state, data) => {
      state.replyData.dropedFiles = data
    },
    setExistingAttachmentIds: (state, data) => {
      state.replyData.existingAttachmentIds = data
    },
    setBlankReplyData: (state, data) => {
      state.replyData.editorData = data,
      state.replyData.toEmailAddress = data,
      state.replyData.CCemailAddress = data,
      state.replyData.BCCemailAddress = data,
      state.replyData.dropedFiles = data,
      state.replyData.existingAttachmentIds = data
    },
  },
  getters: {
    replyData: (state) => state.replyData,
    replyExpanded: (state) => state.replyExpanded,
  }, 
} 